import { useEffect, useMemo } from 'react';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export const useSubject = <T = any>(creator: () => Subject<T> = () => new Subject<T>()) => {
  const subject = useMemo(() => {
    const sub = creator();
    sub.next = sub.next.bind(sub);
    sub.error = sub.error.bind(sub);
    sub.complete = sub.error.bind(sub);
    return sub;
  }, []);

  // useEffect(() => () => subject.observers.length && subject.complete(), []);
  return subject;
};

export const useBehaviorSubject = <T = any>(
  creator: (defaultValue) => BehaviorSubject<T> = defaultValue =>
    new BehaviorSubject<T>(defaultValue)
) => {
  const subject = useMemo(() => {
    const sub = creator('');
    sub.next = sub.next.bind(sub);
    sub.error = sub.error.bind(sub);
    sub.complete = sub.error.bind(sub);
    return sub;
  }, []);

  // useEffect(() => () => subject.observers.length && subject.complete(), []);
  return subject;
};
